import { render, staticRenderFns } from "./ConsumerItem.vue?vue&type=template&id=407004d6"
import script from "./ConsumerItem.vue?vue&type=script&lang=js"
export * from "./ConsumerItem.vue?vue&type=script&lang=js"
import style0 from "./ConsumerItem.vue?vue&type=style&index=0&id=407004d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_84f1f4618b294cfa2aad13d74ae0562d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports